import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getMessagesAccueil } from "../../api/messagesAccueilService";
import { getContributions, getSousCategoriesRef } from "../../api/contributionsService";
import { getMnhPratique } from "../../api/mnhPratiqueService";
import moment from "moment";
import { getReferences } from "../../api/gestionService";

const CONF = window?.confPub;

const PATTERNS = CONF?.PATTERNS

const initialState = {

    referencesApp: null,
    referencesAppLastUpdated: null,
    loadingReferencesApp: false,

    mnhPratique: [],
    mnhPratiqueLastUpdated: null,
    loadingMnhPratique: false,

    contributions: [],
    nombreContributions: 0,
    sousCategoriesRef: [],
    loadingContributions: false,
    contributionsLastUpdated: null,

    messagesAccueil: [],
    loadingMessages: false,
    messagesAccueilLastUpdated: null,
}

export const fetchReferences = createAsyncThunk("fetchReferences",
    async() => {

    return await getReferences()
    })

export const fetchMnhPratique = createAsyncThunk("fetchMnhPratique",
    async() => {

        return await getMnhPratique()
    });

export const fetchMessagesAccueil = createAsyncThunk("fetchMessagesAccueil",
    async() => {

    return await getMessagesAccueil()
});

export const fetchContributionsAndSousCategories = createAsyncThunk("fetchContributionsAndSousCategories", async(params) => {

    const { contributions, nombreContributions } = await getContributions(params)

    const { sousCategoriesRef } = await getSousCategoriesRef()

    return {
        contributions,
        nombreContributions,
        sousCategoriesRef
    }
});

const resourcesSlice = createSlice({
    name: "resources",
    initialState,
    reducers: {
        initContributions(state, action) {
            return{
                ...state,
                ...initialState,
            }
        },
        addContribution(state, action) {
            return {
                contributions: [
                    // eslint-disable-next-line no-unsafe-optional-chaining
                    ...state?.contributions,
                    action?.payload,
                ]
            }
        },
    },
    extraReducers: builder => {
        builder
            .addCase(fetchReferences.pending, (state, action) => {
                state.loadingReferencesApp = true
            })
            .addCase(fetchReferences.fulfilled, (state, action) => {

                const referencesAppLastUpdated = moment().format(PATTERNS?.DD_SLASH_MM_SLASH_YYYY)

                state.referencesApp = action.payload
                state.loadingReferencesApp = false
                state.referencesAppLastUpdated = referencesAppLastUpdated
            })
            .addCase(fetchReferences.rejected, (state, action) => {
                state.loadingReferencesApp = false
                state.error = action?.error?.message
            })

            .addCase(fetchMnhPratique.pending, (state, action) => {
                state.loadingMnhPratique = true
            })
            .addCase(fetchMnhPratique.fulfilled, (state, action) => {

                const mnhPratiqueLastUpdated = moment().format(PATTERNS?.DD_SLASH_MM_SLASH_YYYY)

                state.mnhPratique = action.payload
                state.loadingMnhPratique = false
                state.mnhPratiqueLastUpdated = mnhPratiqueLastUpdated
            })
            .addCase(fetchMnhPratique.rejected, (state, action) => {
                state.loadingConfig = false
                state.error = action?.error?.message
            })

            .addCase(fetchMessagesAccueil.pending, (state, action) => {
                state.loadingMnhPratique = true
            })
            .addCase(fetchMessagesAccueil.fulfilled, (state, action) => {
                state.messagesAccueil = action.payload
                state.loadingMessages = false
            })
            .addCase(fetchMessagesAccueil.rejected, (state, action) => {
                state.loadingConfig = false
                state.error = action?.error?.message
                state.messagesAccueilLastUpdated = moment().format(PATTERNS?.DD_SLASH_MM_SLASH_YYYY_SPACE_HH_COLON_MM_COLON_SS)
            })

            .addCase(fetchContributionsAndSousCategories.pending, (state, action) => {
                state.loadingContributions = true
            })
            .addCase(fetchContributionsAndSousCategories.fulfilled, (state, action) => {
                const { contributions, nombreContributions, sousCategoriesRef } = action.payload

                state.contributions = contributions
                state.nombreContributions = nombreContributions
                state.sousCategoriesRef = sousCategoriesRef
                state.loadingContributions = false
                state.messagesAccueilLastUpdated = moment().format(PATTERNS?.DD_SLASH_MM_SLASH_YYYY_SPACE_HH_COLON_MM_COLON_SS)
            })
            .addCase(fetchContributionsAndSousCategories.rejected, (state, action) => {
                state.loadingContributions = false
                state.error = action?.error?.message
            })
    }
})

// TODO encore utilé ?
export const {
    initContributions,
    addContribution,
} = resourcesSlice.actions

export default resourcesSlice.reducer